import { Navigation } from "./navigation";
import { Contact } from "./contact";
import JsonData from "../data/data.json";
import { useState, useEffect } from "react";

export const DoencasGastro = () => {
    const [data, setData] = useState(null);

    // ---- Função que transforma URLs em <a> ----
    const convertLinks = (text) => {
        if (!text) return text;

        const urlRegex = /(https?:\/\/[^\s]+)/g;

        return text.split(urlRegex).map((part, i) => {
            if (urlRegex.test(part)) {
                return (
                    <a
                        key={i}
                        href={part}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {part}
                    </a>
                );
            }
            return part;
        });
    };
    // -------------------------------------------

    useEffect(() => {
        setData(JsonData.DoencasGastro);
    }, []);

    if (!data) return null;

    return (
        <>
            <Navigation />

            <div id="doencas" className="doctor-page">
                <div className="container">
                    <h1 className="text-center mb-4">{data.title}</h1>

                    <div className="row">
                        {/** Loop nas doenças */}
                        {Object.entries(data)
                            .filter(([key]) => key !== "title")
                            .map(([nomeDoenca, descricao], i) => (
                                <div key={i} className="col-12 mb-4">
                                    <div className="doenca-box shadow p-4 rounded bg-white">
                                        <h3 className="doenca-nome mb-3">{nomeDoenca}</h3>

                                        <p className="white-space-pre-line-alt">
                                            {convertLinks(descricao)}
                                        </p>
                                    </div>
                                </div>
                        ))}
                    </div>
                </div>
            </div>

            <Contact data={JsonData.Contact} />
        </>
    );
};
